import React from "react";
import { TablePagination } from "components/pagination";
import { Format, ListBuilder, Table } from "@redriver/cinnamon";
import { getClientAuthorisedSignatories } from "features/Companies/Customers/Signatories/actions";
import { Icon } from "semantic-ui-react";
import CustomerSignatoryActions from "features/Companies/Customers/Signatories/CustomerSignatoryActions";
import { SignatoryState as CustomerSignatoryState } from "features/../constants/enums";

const AuthorisedCustomerSignatoryTable = ({
  clientId,
  onAdded,
  forceUpdate,
}) => {
  const handleSignatoryStateIcon = (state) => {
    switch (state) {
      case CustomerSignatoryState.Authorised:
        return <Icon name="check" />;
      case CustomerSignatoryState.Rejected:
        return <Icon name="close" />;
      default:
        return;
    }
  };

  return (
    <ListBuilder
      withTable
      initialPagination={{ pageSize: 25, pageNumber: 1 }}
      dataTransform={(data) => data.results}
      totalTransform={(data) => data.totalResults}
      loadAction={getClientAuthorisedSignatories}
      loadParams={{ clientId, onAdded }}
      renderList={(tableProps, state, events) => (
        <div className="content-container principal-list">
          <Table
            {...tableProps}
            dataKey="id"
            emptyMessage="No Signatories Found"
            selectable
            className="center-align"
          >
            <Table.Column field="name" title="Full Name" width="15%" />
            <Table.Column field="position" title="Position" width="15%" />
            {process.env.TRADE_AS_IPS && (
              <Table.Column
                title="Authorised Status"
                render={(item) => item.statusDescription}
                width="15%"
              />
            )}
            <Table.Column
              title="Telephone"
              render={(item) =>
                `+${item.phoneCountryCode} (0) ${item.phoneNumber}`
              }
              width="15%"
            />
            <Table.Column field="email" title="Email" width="15%" />
            <Table.Column
              title="Date Added"
              render={(item) => <Format.DateTime value={item.createdUtc} />}
              width="15%"
            />
            {process.env.TRADE_AS_IPS && (
              <Table.Column
                title="Authorised"
                render={(item) => handleSignatoryStateIcon(item.state)}
                width="15%"
              />
            )}
            {process.env.TRADE_AS_IPS && (
              <Table.Column
                width="15%"
                render={(item) => (
                  <CustomerSignatoryActions
                    state={item.state}
                    isArchived={item.isArchived}
                    signatoryId={item.id}
                    clientId={clientId}
                    forceUpdate={forceUpdate}
                  />
                )}
              />
            )}
          </Table>
          <TablePagination
            pageNumber={state.pagination.pageNumber}
            onChange={events.onChangePagination}
            pageSize={state.pagination.pageSize}
            totalItems={state.total}
          />
        </div>
      )}
    />
  );
};
export default AuthorisedCustomerSignatoryTable;
